import { FC } from 'react';

import {
  Button,
  SpaceBetween,
  FormField,
  Input,
  Form,
  Flashbar,
  Checkbox
} from '@awsui/components-react';

import { Formik } from 'formik';
import * as yup from 'yup';

import { FlashbarProps } from '@awsui/components-react';
import { IUpdateSupportTopic } from '../../../../../interfaces/portal/supportTopic';

interface ViewProps {
  formValues: IUpdateSupportTopic;
  flashBarItems: FlashbarProps.MessageDefinition[];
  handleSubmittedForm: (data: IUpdateSupportTopic) => Promise<void>;
}

const View: FC<ViewProps> = ({
  formValues,
  flashBarItems,
  handleSubmittedForm
}) => {
  const validationSchema = yup.object({
    topicName: yup.string().required().min(3)
  });

  return (
    <>
      <Formik
        enableReinitialize={true}
        validateOnChange={true}
        initialValues={formValues}
        validationSchema={validationSchema}
        onSubmit={(data, { setSubmitting, resetForm }) => {
          setSubmitting(true);
          handleSubmittedForm(data).then((resp) => {
            resetForm();
            setSubmitting(false);
          });
        }}
      >
        {({ values, errors, isSubmitting, setFieldValue, handleSubmit }) => (
          <SpaceBetween direction="vertical" size="xs">
            <Flashbar items={flashBarItems} />
            <Form
              actions={
                <SpaceBetween direction="horizontal" size="xs">
                  <Button
                    variant="primary"
                    onClick={() => handleSubmit()}
                    disabled={isSubmitting}
                  >
                    Submit
                  </Button>
                </SpaceBetween>
              }
            >
              <FormField label="Name" errorText={errors.topicName}>
                <Input
                  name="topicName"
                  value={values.topicName}
                  onChange={({ detail }) =>
                    setFieldValue('topicName', detail.value)
                  }
                  invalid={!!errors.topicName}
                />
              </FormField>

              <FormField>
                <Checkbox
                  name="deprecated"
                  checked={values.deprecated === 1}
                  onChange={({ detail }) =>
                    setFieldValue('deprecated', detail.checked ? 1 : 0)
                  }
                >
                  Deprecated
                </Checkbox>
              </FormField>
            </Form>
          </SpaceBetween>
        )}
      </Formik>
    </>
  );
};
export default View;
